@if (loading() || previousOrders.isLoading()) {
  <cue-loading />
} @else {
  @if (showConfirmation()) {
    <div class="w-full flex flex-col gap-4 items-center mb-4">
      <div class="notification-inner">
        <cue-icon [icon]="ICONS.cueCheckCircle" class="icon" />
        <div class="flex flex-column gap-1">
          <h2>{{ translation.orders.created | transloco }}</h2>
        </div>
      </div>

      <cue-button (click)="showConfirmation.set(false)" [icon]="ICONS.cueOrders" [type]="'service'">
        {{ translation.orders.newServiceRequest | transloco }}
      </cue-button>
    </div>
  } @else {
    <div class="order-wrapper new-order" [formGroup]="form">
      @if (form.controls.items.length === 0) {
        <h4>{{ translation.orders.newServiceTitle | transloco }}</h4>
        <p>{{ translation.orders.newServiceInstruction | transloco }}</p>
      }
      @for (order of orders.controls; track order; let index = $index) {
        <ng-container [formGroup]="$any(order)">
          <div class="order-item">
            <div class="image-wrapper">
              <img
                [src]="
                  (order.value.imageUrl === null || order.value.imageUrl === ''
                    ? 'assets/images/placeholder-order.svg'
                    : order.value.imageUrl
                  ) | imageWidth: 100
                "
                class="service-image"
              />
            </div>
            <div class="text-wrapper">
              <div class="item-heading">
                <p>
                  {{ order.value.name }}
                </p>
              </div>
              <div class="item-inner-count">
                @if (order.value.noteAllowed) {
                  <textarea cueRtl [class.error]="order.get('note').invalid" formControlName="note"></textarea>
                  @if (order.get('note').invalid) {
                    <p class="error">
                      {{ translation.orders.minimalLength | transloco: { length: order.get('noteMinLength').value } }}
                    </p>
                  }
                }
              </div>
            </div>
            <div (click)="remove(index)" class="delete-button">
              <cue-icon [icon]="ICONS.cueClose" />
            </div>
          </div>
        </ng-container>
      }

      <div class="order-select">
        @if (adding()) {
          <assist-service-select
            type="resource"
            (cancelled)="onCancel()"
            (itemSelected)="onSelect($event)"
            [resourceGuid]="resource().id"
          />
        }
      </div>

      <br />

      @if (!adding()) {
        <div (click)="add()" class="add-item-button">
          <cue-icon [icon]="ICONS.cueAdd" />
          {{ translation.orders.addItem | transloco }}
        </div>
      }

      @if (orders.length > 0) {
        <div class="order-note">
          <h4>{{ translation.orders.note | transloco }}</h4>
          <textarea cueRtl formControlName="note"> </textarea>
        </div>
      }

      <div class="w-full flex flex-row justify-center my-4">
        <cue-button (click)="order()" [disabled]="orders.length === 0" [icon]="ICONS.cueOrders" [type]="'service'">
          {{ translation.orders.newRequest | transloco }}
        </cue-button>
      </div>
    </div>
  }

  <div class="orders-grid">
    @for (orderItem of previousOrders.value(); track orderItem) {
      <assist-order-item-card [gridOrder]="orderItem" (detailClicked)="onDetailClicked(orderItem)" />
    }
  </div>
}
